import React, { useEffect, useState } from "react";
import { DeleteAttachment, FetchAttachment } from "./_requests";
import { toAbsoluteUrl } from "../../_helpers";
import SVG from "react-inlinesvg";
import { HasDeleteAccess, IsSuperUser} from "../../_helpers/AccessControlHelpers";
import AttachmentViewer from "./AttachmentViewer";
import {ATTACHMENT_MODEL} from "../../_helpers/AppModels";

export function AttachmentItem({
  attachmentId,
  attachmentName,
  user,
  onFileDelete,
}) {
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [url, setUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const thumbnail = attachmentName?.split(".").pop();

  const deleteFile = () => {
    DeleteAttachment(attachmentId).then(() => {
      onFileDelete();
    });
  };

  useEffect(() => {
    FetchAttachment(attachmentId)
      .then((response) => {
        setUrl(URL.createObjectURL(response.data));
      })
      .catch((err) => {
        console.log(err);
        setHasError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // trigger modal
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      {/* begin::Popup Modal */}
      {url && (
        <AttachmentViewer
          openModal={openModal}
          handleClose={handleClose}
          url={url}
          attachmentName={attachmentName}
        />
      )}
      {/* end::Popup Modal */}

      {/* begin::Button */}
      <div
        role="button"
        tabIndex={"0"}
        style={{ minWidth: 100, minHeight: 50 }}
        className={`cursor-pointer p-2 rounded-lg ${
          hasError ? "bg-danger-o-100" : "bg-secondary"
        } bg-hover-primary-o-1 ml-3 mb-3 d-flex align-items-center justify-content-center`}
        onClick={() => {
          handleOpen();
        }}
      >
        {loading && <div className="spinner spinner-primary w-100 h-100" />}

        {!loading && (
          <div>
            {url && (
              <div
                className={"d-flex flex-column align-items-center"}
                style={{ gap: "4px" }}
              >
                <div className={"w-80px h-50px"}>
                  {attachmentName.includes(".jpg") ||
                  attachmentName.includes(".png") ||
                  attachmentName.includes(".jpeg") ? (
                    // Preview thumbnail for photo
                    <img
                      src={url}
                      alt="Media content"
                      className={"max-w-100 w-100 max-h-100 h-100"}
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    // Preview icon for PDF & Audio & Video
                    <SVG
                      style={{ width: 90 }}
                      src={toAbsoluteUrl(
                        `/media/svg/icons/Files/${thumbnail}.svg`
                      )}
                    />
                  )}
                </div>

                <div className={"w-100 h-100 d-flex align-items-center"}>
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")} />

                  <b className={"mx-4"}>{attachmentName}</b>
                  <div
                    className={"d-flex gap-8 flex-row align-items-center"}
                    style={{ gap: "4px" }}
                  >
                    <SVG
                      style={{ width: 15 }}
                      src={toAbsoluteUrl("/media/svg/icons/Files/Eye.svg")}
                    />

                    {(HasDeleteAccess(user, ATTACHMENT_MODEL) || IsSuperUser(user)) && (
                      <SVG
                        style={{ width: 15 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteFile();
                        }}
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Trash.svg"
                        )}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {hasError && (
              <>
                {(HasDeleteAccess(user, ATTACHMENT_MODEL) || IsSuperUser(user)) && (
                  <div className={"w-100 h-100 d-flex justify-content-center"}>
                    <SVG
                      style={{ width: 15 }}
                      onClick={() => deleteFile()}
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {/* end::Button */}
    </>
  );
}
